/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

import { SelectListCardHeadingInfo } from './heading-info-popup';

export interface GroupHeadingProps {
	groupDescription?: string;
	groupDescriptionIcon?: React.ReactElement<any>;
	groupDescriptionInfoLink?: string;
	groupDescriptionInfoLinkMessage?: string;
	groupId: string;
	groupName?: string;
	testId: string;
}

const cardHeadingContainerStyles = css({
	fontStyle: 'normal',
	font: token('font.heading.small'),
	color: token('color.text'),
	display: 'flex',
	gap: token('space.050'),
});

export const GroupHeading = (props: GroupHeadingProps): React.JSX.Element | null => {
	const {
		testId,
		groupId,
		groupName,
		groupDescription,
		groupDescriptionIcon,
		groupDescriptionInfoLink,
		groupDescriptionInfoLinkMessage,
	} = props;

	if (!groupName) {
		return null;
	}

	return (
		<legend css={[cardHeadingContainerStyles]} data-testid={`${testId}-${groupId}-title`}>
			{groupName}
			<SelectListCardHeadingInfo
				testId={`${testId}-${groupId}-popup-card`}
				groupDescription={groupDescription}
				groupDescriptionInfoLink={groupDescriptionInfoLink}
				groupDescriptionIcon={
					groupDescriptionIcon &&
					React.cloneElement(groupDescriptionIcon, {
						size: 'small',
					})
				}
				groupDescriptionInfoLinkMessage={groupDescriptionInfoLinkMessage}
				groupName={groupName}
			/>
		</legend>
	);
};
